import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { changeJob, fetchJob } from "../../features/jobs/jobsSlice";

export default function Form() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [newTitle, setTitle] = useState("");
  const [newType, setType] = useState("");
  const [newSalary, setSalary] = useState("");
  const [newDeadline, setDeadline] = useState("");

  const job = useSelector((state) => state.jobs.editing);

  const { title, type, salary, deadline } = job || {};

  useEffect(() => {
    dispatch(fetchJob(id));

    setTitle(title);
    setType(type);
    setSalary(salary);
    setDeadline(deadline);
    
  }, [dispatch, id, title, type, salary, deadline]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      changeJob({
        id,
        data: {
          title: newTitle,
          type: newType,
          deadline: newDeadline,
          salary: newSalary,
        },
      })
    );
    navigate("/");
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div className="fieldContainer">
        <label
          htmlFor="lwsJobTitle"
          className="text-sm font-medium text-slate-300"
        >
          Job Title
        </label>
        <select
          id="lwsJobTitle"
          name="lwsJobTitle"
          autoComplete="lwsJobTitle"
          required
          value={newTitle}
          onChange={(e) => setTitle(e.target.value)}
        >
          <option defaultValue hidden>
            Select Job
          </option>
          <option>Software Engineer</option>
          <option>Software Developer</option>
          <option>Full Stack Developer</option>
          <option>MERN Stack Developer</option>
          <option>DevOps Engineer</option>
          <option>QA Engineer</option>
          <option>Product Manager</option>
          <option>Social Media Manager</option>
          <option>Senior Executive</option>
          <option>Junior Executive</option>
          <option>Android App Developer</option>
          <option>IOS App Developer</option>
          <option>Frontend Developer</option>
          <option>Frontend Engineer</option>
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lwsJobType">Job Type</label>
        <select
          id="lwsJobType"
          name="lwsJobType"
          autoComplete="lwsJobType"
          required
          value={newType}
          onChange={(e) => setType(e.target.value)}
        >
          <option defaultValue hidden>
            Select Job Type
          </option>
          <option>Full Time</option>
          <option>Internship</option>
          <option>Remote</option>
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lwsJobSalary">Salary</label>
        <div className="flex border rounded-md shadow-sm border-slate-600">
          <span className="input-tag">BDT</span>
          <input
            type="number"
            name="lwsJobSalary"
            id="lwsJobSalary"
            required
            className="!rounded-l-none !border-0"
            placeholder="20,00,000"
            value={newSalary}
            onChange={(e) => setSalary(e.target.value)}
          />
        </div>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lwsJobDeadline">Deadline</label>
        <input
          type="date"
          name="lwsJobDeadline"
          id="lwsJobDeadline"
          required
          value={newDeadline}
          onChange={(e) => setDeadline(e.target.value)}
        />
      </div>

      <div className="text-right">
        <input
          type="submit"
          value="Edit"
          className="lws-submit cursor-pointer btn btn-primary w-fit"
        />
      </div>
    </form>
  );
}
